import type { Sx } from "dripsy";
import { useSx } from "dripsy";
import type { ImageContentFit } from "expo-image";
import * as React from "react";
import { StyleSheet } from "react-native";

export default function CustomImage({
  source,
  contentFit,
  sx,
  alt,
  lazy = true,
}: {
  source: { uri: string };
  contentFit?: ImageContentFit;
  sx?: Sx;
  alt: string;
  lazy?: boolean;
}) {
  const generateSx = useSx();

  const [hasError, setHasError] = React.useState(false);
  const style = StyleSheet.flatten(
    generateSx({
      ...sx,
      objectFit: contentFit,
    } as any)
  );
  if (hasError) {
    return <div style={style} />;
  }

  return (
    <img
      src={source.uri || (source as any)}
      style={style}
      onError={() => setHasError(true)}
      alt={alt}
      width={style.width}
      height={style.height}
      decoding={lazy ? "async" : undefined}
      loading={lazy ? "lazy" : undefined}
    />
  );
}
